module.exports = __webpack_public_path__ + "static/media/fit-branco.00fc0ea3.webp";